import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { translate, isNullOrEmpty, showMessageToastCustom, showMessageToast } from '../../../utils/util';
import { BackButton, Title, Subtitle, Button, ListPagination } from '../../../components/UI/ComponentsUI';
import ReprocessListItem from './ReprocessListItem'
import { ENUMS, VISIONS, SITES } from '../../../utils/constants';
import { getVision } from '../../../services/auth';

const ReprocessMonitor = (props) => {
    const [receipts, setReceipts] = useState([])
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [transmissions, setTransmissions] = useState([])

    useEffect(() => {
        setReceipts(props.receipts);
        // eslint-disable-next-line
    }, [props.receipts]);

    useEffect(() => {
        if (!props.receipts.some(e => e.adjusted === true) || currentPage > 0) {
            let { invoice } = props.location?.state;

            let filter = {
                reprocess: true,
                pending: true,
                invoice: invoice,
                notFinished: true,
                site: getSite(getVision()),
                PageSize: ENUMS.ePagination.PageSize.value,
                PageIndex: currentPage
            }

            props.getReceipts(filter, (config) => setTotalPages(config.totalPages));
        }

        // eslint-disable-next-line
    }, [currentPage]);

    const getSite = (vision) => {
        if (vision === VISIONS.Faasa) {
            return SITES.Faasa
        }
        else if (vision === VISIONS.FaasaCKD) {
            return SITES.FaasaCKD
        }
        return ''
    }

    const onSubmit = () => {
        if ((!props.user.shed || props.user.shed === '') && Boolean(props.config.shedRequiredPhysicalConfirmation)) {
            showMessageToast({ html: translate('select-shed', 'validations'), classes: 'red' });
            return;
        }

        if ((!props.user.dock || props.user.dock === '') && Boolean(props.config.dockRequiredPhysicalConfirmation)) {
            showMessageToast({ html: translate('select-dock', 'validations'), classes: 'red' });
            return;
        }
        var dockRequired = Boolean(props.config.shedRequiredPhysicalConfirmation);
        var shedRequired = Boolean(props.config.dockRequiredPhysicalConfirmation);
        var dock = !dockRequired ? "M01" : props.user.dock;
        var shed = !shedRequired ? "" : props.sheds.find((i) => i.id === props.user.shed)?.code;
        let listDto = []
        let adjusteds = props.receipts.filter(x => x.adjusted);

        if (adjusteds.length === 0) {
            return showMessageToastCustom(translate('warning', 'general'), "Nenhum item selecionado", 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        adjusteds.forEach(r => {
            if (r.place === "2") {
                r.preAllocation = "N";
                r.preAllocationArea = dock;
            } else {
                r.preAllocation = "S";
            }

            let dto = {
                id: r.id,
                printer: props.user.printer,
                resource: onChangeResource(),
                preAllocationArea: r.preAllocationArea,
                preAllocation: r.preAllocation,
                print: r.print,
                productionDate: r.productionDate,
                expirationDate: r.productionDate,
                dock: dock,
                shed: shed,
                mdr: r.mdr,
                cimPallet: false,
                boxQuantity: r.boxQuantity,
                boxQuantityItems: r.boxQuantityItems
            };
            listDto.push(dto);
        });

        props.sendReprocess(listDto, (transmissions) => {
            updateReceipts()
            setTransmissions(transmissions)
        });
    }

    const updateReceipts = () => {
        setCurrentPage(0)
        props.getReceipts({
            reprocess: true,
            pending: true,
            invoice: props.location?.state?.invoice
        });
    }

    const onChangeResource = () => {
        try {
            if (!isNullOrEmpty(props.user.resource)) {
                return props.resources.find((i) => i.resourceId === parseInt(props.user.resource)).name;
            }
            return "";
        } catch (error) {
            return "";
        }
    }
    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('reprocess-monitor', 'physical-confirmation')} />
                <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('phisicalconfirmation', 'physical-confirmation')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            {receipts?.length > 0 &&
                                <ListPagination
                                    page={totalPages}
                                    current={{ currentPage, setCurrentPage }}
                                    data={receipts.map((item, index) => {
                                        return (
                                            <ReprocessListItem
                                                {...item}
                                                key={index}
                                                route={{ pathname: 'reprocessEdit', state: { item: item, upload: false } }}
                                            />
                                        );
                                    })
                                    }
                                />
                            }
                            <div className="row" style={{ marginTop: '20px' }}>
                                <Button full="true" onClick={() => onSubmit()} text={translate('send-reprocess', 'physical-confirmation')} />
                            </div>
                            {transmissions.map((item) => (
                                <span key={item.code} className={item.success ? "success-color" : "fourth-text-color"}>
                                    {item.receipt?.partNumberCode} - {item.success ? "OK" : item.message}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        config: state.configReducer.config,
        transmissions: state.physicalConfirmationReducer.transmissions,
        resources: state.logisticsResourceReducer.list,
        user: state.userReducer.user,
        printSelect: state.physicalConfirmationReducer.printSelect,
        receipts: state.physicalConfirmationReducer.receipts,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReceipts: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceipts(filter, callback));
        },
        sendReprocess: (item, callback) => {
            dispatch(PhysicalConfirmationService.insertConfirmationReprocess(item, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReprocessMonitor)));
